import React from 'react';
import { List, ListItem, Stack, Text, TextLink } from '@origin-digital/ods-core';

// TODO: Refactor other solar plan files (solarBoost, solarBoostPlus, businessSolarBoost,
// businessSolarBoostPlus) to use this helper.
// `isVariableTariff` selects the variable feed-in-tariff wording (used by the
// "...Variable" solar plans). Non-variable solar plans keep the original copy.
export const createSolarInfoContent = (planName: string, isVariableTariff = false) => (
  <Stack space="small">
    <Text>With {planName}:</Text>
    <List space="small">
      <ListItem>your solar PV system must be net metered, and</ListItem>
      <ListItem>
        you must not be receiving a feed-in tariff (FIT) under any government scheme.
      </ListItem>
    </List>
    {isVariableTariff ? (
      <Text>
        You'll receive a higher than standard variable FIT until the variable daily export limit is
        reached. The daily export limit is averaged across your billing period (by multiplying the
        number of days in your billing period by the daily export limit). You'll receive our
        standard retailer FIT (as published on our website at the time) if you export more than the
        daily limit. FIT rates are GST inclusive (where applicable).
      </Text>
    ) : (
      <Text>
        You'll receive a higher than standard FIT until the daily export limit of 8kWh is reached.
        The daily export limit is averaged across your billing period (by multiplying the number of
        days in your billing period by the daily export limit). You'll receive our standard retailer
        FIT (as published on our website at the time) if you export more than the daily limit and
        once your energy plan ends. FIT rates are GST inclusive (where applicable). For Victorian
        customers, the{' '}
        <TextLink
          href="https://www.originenergy.com.au/terms-and-conditions/vic-feed-in-tariff/"
          target="_blank"
        >
          Terms and Conditions for Feed-in Tariffs - Victoria
        </TextLink>
        apply to both FITs.
      </Text>
    )}
  </Stack>
);
